import { useQuery } from '@tanstack/react-query';
import { SessionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useSessionsControllerGetSessionByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['sessionsControllerGetSessionById', accessControlScope, args],
        queryFn: async () => {
            const api = new SessionsApi(accessControlConfig);
            return api.sessionsControllerGetSessionById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useSessionsControllerGetSessionByIdQuery.js.map